import accessors from '../accessors';

const canBeCloned = (element) => Boolean(accessors.getCloneConstraintForElement(element));

export default canBeCloned;
